import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Directive({
  selector: '[xIfLoggedIn]',
})
export class IfLoggedInDirective implements OnDestroy, OnInit {
  private _destroy$ = new Subject<void>();

  @Select(AuthState.isLoggedIn) isLoggedIn$: Observable<boolean>;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit(): void {
    this.isLoggedIn$
      .pipe(
        tap((loggedIn) => {
          if (!loggedIn) return this.viewContainer.clear();

          return this.viewContainer.createEmbeddedView(this.templateRef);
        }),
        takeUntil(this._destroy$),
      )
      .subscribe();
  }
}
